import { Button, Stack } from "@mui/joy";
import { Link, useLocation } from "react-router-dom";

const reportPaths = ['/reports', '/reports/new', '/reports/saved'];

export default function ReportButtons() {
    const { pathname } = useLocation();

    if(!reportPaths.includes(pathname.replace(/\/$/, ''))) {
        return null;
    }

    return (
        <Stack gap={1.5} direction={'row'} justifyContent={'center'}>
            <Button size="sm" variant="outlined" component={Link} to={'/reports/new'}>New Report</Button>
            <Button size="sm" variant="outlined" component={Link} to={'/reports/saved'}>Saved Reports</Button>
        </Stack>
    );
}